/**
 * @generated SignedSource<<0aeb179a0841b2362b5efd00f8f08e5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTable_section$data = {
  readonly headerRow: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_row">;
  } | null;
  readonly rows: ReadonlyArray<{
    readonly cells: ReadonlyArray<{
      readonly sortValue: number | null;
      readonly value: string | null;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_row">;
  }>;
  readonly " $fragmentType": "WidgetTable_section";
};
export type WidgetTable_section$key = {
  readonly " $data"?: WidgetTable_section$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_section">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "WidgetTable_row"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTable_section",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetTableRow",
      "kind": "LinkedField",
      "name": "headerRow",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetTableRow",
      "kind": "LinkedField",
      "name": "rows",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WidgetTableCell",
          "kind": "LinkedField",
          "name": "cells",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sortValue",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTableSection",
  "abstractKey": null
};
})();

(node as any).hash = "6349d49a55ffdf37ca7c650d2ff3f76e";

export default node;
